import { render, staticRenderFns } from "./correct.vue?vue&type=template&id=4ce4afa4&scoped=true&"
import script from "./correct.vue?vue&type=script&lang=js&"
export * from "./correct.vue?vue&type=script&lang=js&"
import style0 from "./correct.vue?vue&type=style&index=0&lang=css&"
import style1 from "./correct.vue?vue&type=style&index=1&id=4ce4afa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4afa4",
  null
  
)

export default component.exports